import Button from '@mui/joy/Button'
import Undo from '@mui/icons-material/Undo'

export const UndoButton = ({ onClick, disabled }) => (
    <Button
        variant="outlined"
        color="primary"
        onClick={onClick}
        disabled={disabled}
        startDecorator={<Undo />}
    >
        Undo
    </Button>
)
